import Vue from 'vue';
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';

export function RedeemSuccessModalController () {
    this.campaignGroup = '';
    this.tag = '';
    this.busModal = new Vue();

    //#region relate modal
    this.loadingModal = null;

    this.setLoadingModal = function (loadingModal) {
        this.loadingModal = loadingModal;
    };
    //#endregion relate modal

    //#region callback
    this.cbClose = new CallbackEvent();
    this.cbAction = new CallbackEvent();
    //#endregion callback

    //#region setter
    this.setCampaignGroup = function (campaignGroup) {
        this.campaignGroup = campaignGroup;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function () {
        this.campaignGroup = '';
        this.tag = '';
        this.cbAction.clearCallback();
        this.cbClose.clearCallback();

        return this;
    };
    //#endregion setter

    //#region modal control
    this.show = function () {
        // ปิด loading modal เมื่อแสดง RedeemSuccessModal
        if (this.loadingModal) {
            this.loadingModal.hide();
        }

        var config = {
            campaignGroup: this.campaignGroup,
            tag: this.tag
        };

        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion modal control
}
